import { render } from "./ExperimentsOverview.vue?vue&type=template&id=32d0c0f2&scoped=true"
import script from "./ExperimentsOverview.vue?vue&type=script&lang=js"
export * from "./ExperimentsOverview.vue?vue&type=script&lang=js"

import "./ExperimentsOverview.vue?vue&type=style&index=0&id=32d0c0f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d0c0f2"]])

export default __exports__